export * from './ICommingSoonComponent';
